import React from 'react';
import { useNavigate } from '@tanstack/react-router';

import type { Memory } from '../../types/memory';
import type { Timeline } from '../../types/timeline';

interface MemoryTimelineHeaderProps {
  memory: Memory;
  timeline: Timeline;
};

const MemoryTimelineHeader: React.FC<MemoryTimelineHeaderProps> = ({ memory, timeline }) => {
  const nav = useNavigate();

  const currentMemoryIndex = timeline.memories.findIndex((m) => m.id === memory.id);
  const nextMemoryIndex = currentMemoryIndex < timeline.memories.length - 1 ? currentMemoryIndex + 1 : null;
  const prevMemoryIndex = currentMemoryIndex > 0 ? currentMemoryIndex - 1 : null;

  const prevMemory = prevMemoryIndex !== null ? timeline.memories[prevMemoryIndex] : null;
  const nextMemory = nextMemoryIndex !== null ? timeline.memories[nextMemoryIndex] : null;

  return (
    <div className="memory-timeline-header">
      <div className="memory-timeline-header-inner wa-cluster">
        <div className="memory-timeline-header-prev">
          {prevMemory && (
            <wa-card onClick={() => nav({ to: `/t/${timeline.id}/${prevMemory.id}` })}>
              <div className="wa-cluster">
                <i className="fa-light fa-chevron-left" slot="start" />
                <div className="wa-stack wa-gap-0">
                  <div className="memory-timeline-header-label">Previous</div>
                  <div><strong>{prevMemory.title}</strong></div>
                </div>
              </div>
            </wa-card>
          )}
        </div>
        <div className="memory-timeline-header-center">
          <wa-button size="xs" appearance="filled-outlined" onClick={() => nav({ to: `/t/${timeline.id}` })}>
            <i className="fa-light fa-list-timeline" slot="start" />
            All Memories
          </wa-button>
        </div>
        <div className="memory-timeline-header-next">
          {nextMemory && (
            <wa-card onClick={() => nav({ to: `/t/${timeline.id}/${nextMemory.id}` })}>
              <div className="wa-cluster">
                <div className="wa-stack wa-gap-0">
                  <div className="memory-timeline-header-label">Next</div>
                  <div><strong>{nextMemory.title}</strong></div>
                </div>
                <i className="fa-light fa-chevron-right" slot="end" />
              </div>
            </wa-card>
          )}
        </div>
      </div>
    </div>
  );
}

export default MemoryTimelineHeader;
